import { Component } from '@angular/core';

@Component({
    selector: 'app-head',
    templateUrl: './head.component.html',
    styleUrls: ['./head.component.css'],
    standalone: false
})
export class HeadComponent {

  constructor() { }

}
